import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useAuthProvider } from '@maui-mf/common-react'
import { InfoTooltip } from '../../common/Tooltip'
import {
  Box,
  Icon,
  Table,
  TableBody,
  TableData,
  TableHead,
  TableHeader,
  TableRow,
  Text
} from '@maui/elements'
import { useValidationFetch } from './hooks'
import ValidateButton from './ValidateButton'

function ExpandedRow({ action }) {
  const [expanded, setExpanded] = useState(false)
  const onClick = () => {
    setExpanded(!expanded)
  }
  if (!action) return null
  return (
    <>
      <TableRow key='main'>
        <TableData onClick={onClick}>
          <Icon name={expanded ? 'chevron-down' : 'chevron-right'} color='colorActionPrimary' />
        </TableData>
        <TableData title={action.name}>{action.name}</TableData>
        <TableData>{action.id}</TableData>
      </TableRow>
      {expanded && (
        <TableRow key="tr-expander">
          <TableData colSpan={6}>
            { action.description
              ? (
                <div>
                  <Box as='h6' fontSize='12px' line-height='16px' display='inline'>
                    Action Description
                  </Box>
                  <Text as='p' fontSize='12px' lineHeight='16px'>
                    {action.description ? action.description : 'No description available'}
                  </Text>
                </div>
                )
              : <Text as='p' fontSize='12px' lineHeight='16px'>No Description Available</Text>
            }
          </TableData>
        </TableRow>
      )}
    </>
  )
}

ExpandedRow.propTypes = {
  action: PropTypes.object,
}

const ValidationsWidget = ({ count, actions = [], techniqueId }) => {
  return (
    <Box marginBottom='spaceGapLarge'>
      <Box as='h3' fontSize='14px' line-height='16px' color='colorTextMain'>
        Validations <InfoTooltip tooltip="Test your security control performance in the Mandiant Security Validation module"/>
      </Box>
      <Box display='flex' marginBottom='spaceGapLarge'>
        <Text as='span' display='flex' flex='1' fontSize='14px' lineHeight='16px' color='colorTextMain' marginBottom='spaceGapMedium'>
          {count} Actions Available
        </Text>
        <ValidateButton techniqueId={techniqueId}/>
      </Box>
      {!!actions.length && (
        <Box>
          <Table>
            <TableHead>
              <TableRow>
                <TableHeader width='5%'></TableHeader>
                <TableHeader width='85%'>Name</TableHeader>
                <TableHeader width='10%'>VID</TableHeader>
              </TableRow>
            </TableHead>
            <TableBody>
              {actions.map((action, index) => {
                return <ExpandedRow action={action} key={index} />
              })}
            </TableBody>
          </Table>
        </Box>
      )}
    </Box>
  )
}

ValidationsWidget.propTypes = {
  actions: PropTypes.array,
  count: PropTypes.number,
  techniqueId: PropTypes.string
}

const MitreAttackValidationSection = ({ techniqueId }) => {
  const { userinfo } = useAuthProvider()
  const { data } = useValidationFetch({ id: techniqueId, appHosts: userinfo?.app_hosts })
  if (!data) return null
  if (data?.count === 0) return null
  return (
    <Box>
      <Box
        borderWidth='1px'
        borderColor='colorBorderMain'
        borderStyle='solid'
      />
      <ValidationsWidget
        count={data.count}
        actions={data.actions}
        techniqueId={techniqueId}
      />
      <Box
        borderWidth='1px'
        borderColor='colorBorderMain'
        borderStyle='solid'
      />
    </Box>
  )
}

MitreAttackValidationSection.propTypes = {
  techniqueId: PropTypes.number,
  userInfo: PropTypes.object,
}

export default MitreAttackValidationSection
